<template>
  <div
    class="tw-grid tw-grid-cols-[max-content_1fr_1fr_1fr_1fr_1fr_1fr_max-content] tw-gap-[16px] tw-items-center tw-py-[24px] tw-border-t tw-border-[rgba(0,0,0,0.1)]"
  >
    <div>
      <button
        class="tw-flex tw-items-center tw-justify-center tw-w-[28px] tw-h-[28px] tw-rounded-full tw-bg-[var(--event-secondary)]"
        @click="editContact"
      >
        <icon-pin-card />
      </button>
    </div>
    <div class="tw-text-[16px] md:tw-text-[18px] tw-text-[var(--my-black)]">
      {{ `${item.first_name} ${item.last_name}` }}
    </div>
    <div class="tw-flex tw-justify-center tw-min-w-[0] md:tw-min-w-[124px] mb-[6px] md:mb-[0]">
      <status-badge :status="item.status" />
    </div>
    <div>Last Action</div>
    <div>TeamID: {{ item.team_id }}</div>
    <div>Parent Team</div>
    <div>G-Parent Team</div>
    <router-link
      :to="`/my-team-contacts/${item.id}`"
      class="tw-flex tw-items-center tw-justify-center tw-w-[34px] tw-h-[34px] tw-text-[var(--my-text-color)] hover:tw-text-[var(--my-primary)] tw-transition-colors"
    >
      <icon-arrow-right />
    </router-link>
  </div>
</template>

<script setup>
import statusBadge from "@/views/donor-dashboard/my-contacts/ui/my-status-badge.vue";
import iconArrowRight from "@/views/donor-dashboard/my-contacts/icons/arrow-right.vue";
import iconPinCard from "@/views/event-page/icons/pin-card.vue";
import { notificationsMixin } from "@/mixins";
import { useTeamLeaderContacts } from "@/composables/useDashboardTeamLeaderContacts";
import { getCurrentInstance } from "vue";

const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
});

const vm = getCurrentInstance();
const { fetchContactById } = useTeamLeaderContacts();

const notificationsMixinHandleCatch =
  notificationsMixin.methods.$_notificationsMixin_handleCatch.bind(vm.proxy);

const editContact = () => {
  fetchContactById(props.item.id)
    .then((data) => {
      vm.proxy.$root.$emit("bv::show::modal", "my-add-contact-popup");
      vm.proxy.$root.$emit("my-add-contact-popup-data", { edit: true, data });
    })
    .catch((err) => {
      notificationsMixinHandleCatch(err);
    });
};
</script>

<style lang="scss" scoped>
.first {
  @media screen and (max-width: 767px) {
    border-top: none;
  }
}
</style>
